module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("fcIvx"))).then(() => parcelRequire('3HOfK'));